import {get as getConfig} from '@mailonline/dmg-ads-core/src/config'

export default (async () => {
  const locationFile = 'https://cdn.metro.co.uk/geo/locationjson.html'
  return new Promise(async (resolve, reject) => {
    try {
      resolve({
        ...await (await fetch(locationFile))?.json(),
        ...getConfig('geo', {})
      })
    } catch (e) {
      resolve({
        "Country": "UK", 
        "REGION_CODE": "GB", 
        "CITY": "LONDON", 
        "INEU": true, 
        "INUS": false
      })
    }
  })
})()
